var map = {
	"./Bayer_04_Leverkusen_Union_Berlin_18.01.2025.tsx": 401,
	"./Borussia_Dortmund_VfL_Bochum_27.09.2024.tsx": 560,
	"./Eintracht_Frankfurt_VfL_Wolfsburg_29.09.2024.tsx": 329,
	"./England_Deutschland_25.10.2024.tsx": 265,
	"./FC_Bayern_Arsenal_09.10.2024.tsx": 538,
	"./Galatasaray_Istanbul_VfL_Wolfsburg_13.11.2024.tsx": 106,
	"./SC_Sand_Union_Berlin_06.10.2024.tsx": 209,
	"./Schweiz_Deutschland_29.11.2024.tsx": 162,
	"./Union_Berlin_VfL_Bochum_09.12.2024.tsx": 952,
	"./VfL_Wolfsburg_FC_Bayern_12.10.2024.tsx": 384,
	"./VfL_Wolfsburg_Galatasaray_Istanbul_20.11.2024.tsx": 966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;